/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FailureTaskDto
 */
export interface FailureTaskDto {
    /**
     * 
     * @type {string}
     * @memberof FailureTaskDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureTaskDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FailureTaskDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FailureTaskDto
     */
    isActive?: boolean;
}

export function FailureTaskDtoFromJSON(json: any): FailureTaskDto {
    return FailureTaskDtoFromJSONTyped(json, false);
}

export function FailureTaskDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureTaskDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
    };
}

export function FailureTaskDtoToJSON(value?: FailureTaskDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
        'description': value.description,
        'isActive': value.isActive,
    };
}


